import { EditIcon } from "@chakra-ui/icons";
import {
  Button,
  FormControl,
  FormLabel,
  IconButton,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Tooltip,
  useDisclosure,
} from "@chakra-ui/react";
import { useRef, useState } from "react";
import { BsBoxArrowInLeft } from "react-icons/bs";
import { IoMdAddCircle } from "react-icons/io";
import { MdOutlineSaveAlt } from "react-icons/md";

export const ModalAddParceirosContatos = (dados) => {
  const OverlayOne = () => (
    <ModalOverlay
      bg="blackAlpha.300"
      backdropFilter="blur(10px) hue-rotate(90deg)"
    />
  );

  const OverlayTwo = () => (
    <ModalOverlay
      bg="none"
      backdropFilter="auto"
      backdropInvert="80%"
      backdropBlur="2px"
    />
  );

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [overlay, setOverlay] = useState(<OverlayOne />);
  const initialRef = useRef();
  const finalRef = useRef();

  let [NomeContato, setNomeContato] = useState(dados.contact == undefined ? null : dados.contact.nome_contato);
  let [TelefoneContato, setTelefoneContato] = useState(dados.contact == undefined ? null : dados.contact.telefone_contato);
  let [EmailContato, setEmailContato] = useState(dados.contact == undefined ? null : dados.contact.email_contato);
  let [CodigoContato, setCodigoContato] = useState(dados.contact == undefined ? null : dados.contact.codigo_contato);
  

  let loadData = () =>{
    setNomeContato(dados.contact == undefined ? null : dados.contact.nome_contato);
    setTelefoneContato(dados.contact == undefined ? null : dados.contact.telefone_contato);
    setEmailContato(dados.contact == undefined ? null : dados.contact.email_contato);
    setCodigoContato(dados.contact == undefined ? null : dados.contact.codigo_contato);
  }

  // if(dados.contact != undefined){
  //   NomeContato = dados.contact.nome_contato;
  //   TelefoneContato = dados.contact.telefone_contato;
  //   EmailContato = dados.contact.email_contato;
  // }
  
  return (
    <>
      <Tooltip
        hasArrow
        bg={dados.contact != undefined ? "#03a9f4":"#ff8045"}
        label={dados.contact != undefined ? "Editar Contato" : "Adicionar Contato"}
        placement="left-start"
      >
        {dados.contact != undefined ?
          <Button
            variant="link"
            leftIcon={<EditIcon color="#03a9f4" />}
            color="#03a9f4"
            boxShadow="none !important"
            onClick={() => {
              setOverlay(<OverlayTwo />);
              loadData();
              onOpen();
            }}
          >
            Editar
          </Button>
          :
          <IconButton
            size="sm"
            _hover={{ opacity: 0.8 }}
            bgColor="#ff8045"
            aria-label="Search database"
            icon={<IoMdAddCircle color="white" size="25px" />}
            boxShadow="none !important"
            onClick={() => {
              setOverlay(<OverlayTwo />);
              loadData();
              onOpen();
            }}
          />
        }
        
      </Tooltip>
      <Modal
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
        isCentered
      >
        {overlay}
        <ModalContent>
          <ModalHeader>Adicionar Contato</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl>
              <FormLabel>Nome</FormLabel>
              <Input 
                  ref={initialRef}
                  placeholder="Nome"
                  value={NomeContato}
                  onChange={(e)=>setNomeContato(e.target.value)}/>
            </FormControl>

            <FormControl mt={4}>
              <FormLabel>Telefone</FormLabel>
              <Input 
                  placeholder="Sobrenome"
                  value={TelefoneContato}
                  onChange={(e)=>setTelefoneContato(e.target.value)}/>
            </FormControl>

            <FormControl mt={4}>
              <FormLabel>Email</FormLabel>
              <Input 
                  placeholder="Sobrenome"
                  value={EmailContato}
                  onChange={(e)=>setEmailContato(e.target.value)}/>
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button
              focusBorderColor="#03a9f4"
              leftIcon={<MdOutlineSaveAlt color="white" size="25px" />}
              boxShadow="none !important"
              _hover={{ opacity: 0.8 }}
              bgColor="#03a8f4"
              color="white"
              mr={3}
              onClick={()=>dados.insertNewContact({"codigo_parceiro":dados.data.codigo_parceiro,
                                                   "nome_contato":NomeContato,
                                                   "telefone_contato":TelefoneContato,
                                                   "email_contato":EmailContato,
                                                   "codigo_contato":CodigoContato,
                                                  })}
            >
              Salvar
            </Button>
            <Button
              color="white"
              _hover={{ opacity: 0.8 }}
              boxShadow="none !important"
              bgColor="#ff9045"
              leftIcon={<BsBoxArrowInLeft size="25px" />}
              onClick={onClose}
            >
              Fechar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
